export enum TaskStatus {
  ToDo = 'TODO',
  InProgress = 'IN_PROGRESS',
  Done = 'DONE',
}
